export const CACHE_FETCH = 3600
export const CACHE_PREFETCH = 1800
